import { AxiosResponseHeaders } from 'axios';
import { StandingOrdersResponseDTO } from '../entities';

const standingOrdersDTOToStandingOrdersAdapter = (data: StandingOrdersResponseDTO, headers?: AxiosResponseHeaders) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { standingOrdersDTOToStandingOrdersAdapter };
